import { findObjectPaths } from '../components/pages/administration/product/logic/ObjectPaths'

export const findProps = (data, key) => {
  if (data && key) {
    const path = findObjectPaths(data, { key: key })
    return path
  }
}
